import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { format } from 'date-fns';
import { useCallback, useEffect, useState } from 'react';
import { updateOrganisation } from '../api/organisations';
import { getAllOrganisations } from '../api/super-admin';
import { OrganisationDetails } from '../core/global';
import { companySuperAdminShape } from '../data/form-shapes';
import { ErrorMessage } from './error-message';
import { CreateForm } from './form-components';

export const SuperAdminSettingsOrganisations = () => {
  const [openEditOrganisationId, setOpenEditOrganisationId] = useState<null | number>(null)
  const [allOrganislationa, setAllOrganislationa] = useState<OrganisationDetails[]>([])
  const [apiError, setApiError] = useState<string[]>([])
  const [organisationDefaultValues, setOrganisationDefaultValues] = useState<OrganisationDetails | null>(null)

  useEffect(() => {
    // setUserDefaultValues(null)
    if (openEditOrganisationId && allOrganislationa.length > 0) {
      const found = allOrganislationa.find(u => u.id === openEditOrganisationId)
      setOrganisationDefaultValues(found || null)
    } else {
      setOrganisationDefaultValues(null)
    }
  }, [openEditOrganisationId, allOrganislationa])

  const fetchAllOrganisations = useCallback(async () => {
    const res = await getAllOrganisations()
    const {error, response, message} = res
    
    if (error === 200 && response) {
      const results = response?.results || []
      setAllOrganislationa(results)
      setApiError([])
    } else {
      setApiError([message || "An error occurred while fetching organisations."])
    }

  }, [])

  useEffect(() => {
    fetchAllOrganisations()
  }, [])

  const columns: any = [
    {
      field: 'uid',
      headerName: 'ID',
      type: 'number',
      width: 80,
      editable: false,
    },
    {
      field: 'created_at',
      headerName: 'Created at',
      width: 150,
      editable: false,
      valueGetter: (params: any) => {
        return params ? new Date(params) : null;
      },
      valueFormatter: (params: any) => {
        return params ? format(params, 'dd/MM/yy') : 'N/A';
      },
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 300,
      editable: false,
    },
    {
      field: 'city',
      headerName: 'City',
      width: 150,
      editable: false,
    },
    {
      field: 'country',
      headerName: 'Country',
      width: 150,
      editable: false,
    },
    {
      field: 'address',
      headerName: 'Address',
      width: 300,
      editable: false,
      valueGetter: (params: any) => {
        const all = [params?.row?.address || null, params?.row?.address_2 || null, params?.row?.address_3 || null].filter(Boolean).join(', ')
        return `${all}`;
      }
    },
    {
      field: 'vat_number',
      headerName: 'VAT',
      width: 300,
      editable: false,
    },

    {
      field: 'last_modified',
      headerName: 'Last modified',
      width: 150,
      editable: false,
      valueGetter: (params: any) => {
        if (
          params &&
          Array.isArray(params) &&
          params.length > 0
        ) {
          return new Date(params[0]);
        }
      
        return null;
      },
      valueFormatter: (params: any) => {
        return params ? format(params, 'dd/MM/yy HH:mm') : 'N/A';
      },
    },
    {
      field: 'vat_exempt',
      headerName: 'VAT exempt',
      type: 'boolean',
      width: 80,
      editable: false,
    },
    {
      field: 'super_subscriber',
      headerName: 'Super subscriber',
      type: 'boolean',
      width: 80,
      editable: false,
    },
    {
      field: 'can_upload_validations',
      headerName: 'Can upload validations',
      type: 'boolean',
      width: 80,
      editable: false,
    },
    {
      headerName: 'Actions',
      width: 150,
      editable: false,
      renderCell: (params: any) => {
        return <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            setOpenEditOrganisationId(params?.row.id || null)
          }}
        >Edit</Button>
      }
    }
  ];

  return (
    <div>
      <ErrorMessage message={apiError} />
      <DataGrid
        rows={allOrganislationa}
        columns={columns}
        initialState={{
          sorting: {
            sortModel: [{ field: 'created_at', sort: 'asc' }],
          },
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
        pageSizeOptions={[200]}
        disableRowSelectionOnClick
      />
      {openEditOrganisationId && organisationDefaultValues &&
        <CreateForm
          onCancel={() => {
            setOpenEditOrganisationId(null)
          }}
          title={'Edit user'}
          intro={'Edit user details below.'}
          size="medium"
          allowEdit={true}
          shape={companySuperAdminShape}
          defaultValues={organisationDefaultValues}
          isModal
          onSuccess={() => {
            fetchAllOrganisations()
          }}
          onSubmit={(vals) => {
            return updateOrganisation({...vals})
          }}
        />
      }
    </div>
  )
}